import * as React from "react";

export const BackIcon = (props) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" {...props}>
    <path d="m25 26-5-5 5-5" />
  </svg>
);
